module.exports = __webpack_public_path__ + "static/media/img82_R.ba6b2b43.jpg";